const errorToText = {
    REQUIRED: 'Required Field',
    WRONG_EMAIL: 'Wrong Email'
}

export function getErrorsText(error) {
    return errorToText[error] || error
}